import { Hooks } from "@microfrontends/react-components"
import { useEffect, useState } from "react"
import ArrowUpIcon from "../Icons/ArrowUpIcon"
import { GotoWrapper } from "./GotoTop.css"

interface IGotoTopProps {
    trackId: string
}

const GotoTop = (props: IGotoTopProps) => {
    const { trackId } = props
    const [isShow, setShow] = useState<boolean>(false)
    const [isOnTop] = Hooks.useElementOnScreen({
        target: typeof window !== 'undefined' ? document.getElementById(trackId) : null,
        options: {
            threshold: 0.1,
            isUseReactRef: false
        }
    })

    const handleOnClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    useEffect(() => {
        const scrollY = window.scrollY

        if (scrollY > 50) {
            setShow(!isOnTop)
        } else {
            setShow(false)
        }
    }, [isOnTop])

    return isShow ? (
        <GotoWrapper isShow onClick={handleOnClick}>
            <ArrowUpIcon />
        </GotoWrapper>
    ) : null
}

export default GotoTop
